import { VisualizatorSettings } from "../../visualizator-settings";
import { ObjectCreator } from "../../../../../../../web-graphics";

export class ChannelPlotSettings extends VisualizatorSettings {
  constructor(settings) {
    super();
    this.configurations = [];
    const simpleFields = ["id_channel", "showIsolines"];
    for (const key of Object.getOwnPropertyNames(settings)) {
      if (simpleFields.includes(key)) {
        this[key] = settings[key];
      } else if (key == "y") {
        this.y = settings.y.copy();
      } else if (key == "height") {
        this.height = settings.height.copy();
      } else if (key == "configurations") {
        this.configurations = VisualizatorSettings.copySettingsArray(settings.configurations);
      } else {
        if (typeof settings[key] === "object" && settings[key].copy !== undefined) {
          this[key] = settings[key].copy();
        } else if (typeof settings[key] !== "function") {
          this[key] = ObjectCreator.deepCopy(settings[key]);
        }
      }
    }
  }

  copy() {
    return new ChannelPlotSettings(this);
  }
}
